"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const building_blocks_ui_common_1 = require("@acko-tech/building-blocks.ui.common");
const Icon = building_blocks_ui_common_1.styled.img `
  cursor: pointer;
`;
function NavigationBar({ onClick }) {
    const handleClick = () => {
        if (typeof onClick === 'function') {
            onClick();
        }
        else {
            window.history.back();
        }
    };
    return (react_1.default.createElement(building_blocks_ui_common_1.Flex, { onClick: handleClick, mt: "13px" },
        react_1.default.createElement(Icon, { src: "https://central-frontend-prod.ackoassets.com/_next_static/images/building-block-assets/back-icon.svg", alt: "back button" })));
}
exports.default = NavigationBar;
//# sourceMappingURL=back-navigation.js.map